import {
    Eye,
    Trash2,
    Loader2,
} from "lucide-react";

import { useNavigate } from "react-router-dom";

import "../../css/SupportTable.css";

function SupportTable({
    tickets,
    loading,
    onDelete,
    reload,
}) {

    const navigate = useNavigate();

    const handleDelete = async (id) => {

        const confirmDelete = window.confirm(
            "Delete this support ticket?"
        );

        if (!confirmDelete) return;

        try {

            await onDelete(id);

            reload();

        } catch (err) {

            console.error(err);

            alert("Failed to delete ticket.");

        }

    };

    if (loading) {

        return (

            <div className="category-loading">

                <Loader2
                    size={40}
                    className="spin"
                />

                <p>Loading Tickets...</p>

            </div>

        );

    }

    if (tickets.length === 0) {

        return (

            <div className="category-empty">

                <h3>No Tickets Found</h3>

                <p>
                    There are currently no support tickets.
                </p>

            </div>

        );

    }

    return (

        <div className="category-table-wrapper">

            <table className="category-table">

                <thead>

                    <tr>

                        <th>Ticket ID</th>
                        <th>Subject</th>
                        <th>User</th>
                        <th>Category</th>
                        <th>Priority</th>
                        <th>Status</th>
                        <th>Created</th>
                        <th>Actions</th>

                    </tr>

                </thead>

                <tbody>

                    {tickets.map((ticket) => (

                        <tr key={ticket._id}>

                            <td>{ticket.ticketId}</td>

                            <td>{ticket.subject}</td>

                            <td>

                                {ticket.user?.name || "-"}

                            </td>

                            <td>{ticket.category}</td>

                            <td>

                                <span className={`badge priority ${ticket.priority?.toLowerCase()}`}>

                                    {ticket.priority}

                                </span>

                            </td>

                            <td>

                                <span className={`badge status ${ticket.status?.toLowerCase().replace(/\s/g, "-")}`}>

                                    {ticket.status}

                                </span>

                            </td>

                            <td>

                                {new Date(
                                    ticket.createdAt
                                ).toLocaleDateString()}

                            </td>

                            <td>

                                <div className="table-actions">

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            navigate(
                                                `/admin/support/${ticket._id}`
                                            )
                                        }
                                    >

                                        <Eye size={16} />

                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(ticket._id)
                                        }
                                    >

                                        <Trash2 size={16} />

                                    </button>

                                </div>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

}

export default SupportTable;